import React from "react";
import Button from "@mui/material/Button";
import "./ButtonWithGlyphIcon.scss";
import useMediaQuery from "@mui/material/useMediaQuery";

const styles = {
  textTransform: "none",
  color: "#121b2e",
  borderColor: "#f9b90b",
  width: "364px",
  height: "64px",
  fontFamily: "Inter",
  fontStyle: "normal",
  fontSize: "18px",
  borderRadius: "8px",
  borderStyle: "solid",
  cursor: "pointer",
  textAlign: "center",
  padding: "24px 26px",
  justifyContent: "start",
  "& .MuiButton-startIcon": {
    marginRight: "16px",
    "& .MuiSvgIcon-root ": {
      width: "50px",
      height: "50px",
    },
  },
};

const mobileStyles = {
  textTransform: "none",
  color: "#121b2e",
  borderColor: "#f9b90b",
  width: "100%",
  height: "56px",
  fontFamily: "Inter",
  fontStyle: "normal",
  fontSize: "16px",
  borderRadius: "8px",
  borderStyle: "solid",
  cursor: "pointer",
  textAlign: "center",
  padding: "20px 26px",
  justifyContent: "start",
  "& .MuiButton-startIcon": {
    marginRight: "18px",
    "& .MuiSvgIcon-root ": {
      width: "24px",
      height: "24px",
    },
  },
};
function ButtonWithGlyphIcon({ icon, text, click }) {
  const matches = useMediaQuery("(max-width:430px)");
  return (
    <Button
      variant="outlined"
      startIcon={icon}
      sx={matches ? mobileStyles : styles}
      onClick={() => click()}
    >
      {text}
    </Button>
  );
}

export default ButtonWithGlyphIcon;
